export default __webpack_public_path__ + "static/media/arrow-down-white.d5c96af9.svg";